import { render, staticRenderFns } from "./amenities.html?vue&type=template&id=8aa14880&scoped=true&external"
import script from "./amenities.js?vue&type=script&lang=js&external"
export * from "./amenities.js?vue&type=script&lang=js&external"
import style0 from "./amenities.scss?vue&type=style&index=0&id=8aa14880&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa14880",
  null
  
)

export default component.exports